import React, { useEffect, useState } from "react";
import { apiClient } from "../../lib/api";
import { useI18n } from "../../lib/i18n";
import { Image as ImageIcon, Plus, Trash2 } from "lucide-react";

const empty = { title: "", subtitle: "", image: "", link: "", cta_label: "", position: 0, active: true };

export default function BannersTab() {
  const { lang } = useI18n();
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(empty);

  const load = () => apiClient.get("/admin/banners").then(({ data }) => setItems(data.items || []));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    await apiClient.post("/admin/banners", form);
    setForm(empty);
    load();
  };
  const toggle = async (b) => { await apiClient.patch(`/admin/banners/${b.id}`, { active: !b.active }); load(); };
  const del = async (id) => {
    if (!window.confirm(lang === "ar" ? "حذف البنر؟" : "Delete banner?")) return;
    await apiClient.delete(`/admin/banners/${id}`); load();
  };

  return (
    <div data-testid="admin-banners" className="space-y-6">
      <h2 className="font-display text-2xl flex items-center gap-2"><ImageIcon className="w-5 h-5 text-[#8a6f2e]" /> {lang === "ar" ? "بنرات الصفحة الرئيسية" : "Homepage banners"} ({items.length})</h2>

      <form onSubmit={submit} className="surface rounded-xl p-6 grid sm:grid-cols-2 gap-3">
        <input className="input-dark" placeholder={lang === "ar" ? "العنوان" : "Title"} value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} required data-testid="banner-title" />
        <input className="input-dark" placeholder={lang === "ar" ? "النص الفرعي" : "Subtitle"} value={form.subtitle} onChange={(e) => setForm({ ...form, subtitle: e.target.value })} data-testid="banner-subtitle" />
        <input className="input-dark sm:col-span-2" placeholder={lang === "ar" ? "رابط الصورة" : "Image URL"} value={form.image} onChange={(e) => setForm({ ...form, image: e.target.value })} required data-testid="banner-image" />
        <input className="input-dark" placeholder={lang === "ar" ? "رابط الوجهة" : "Destination link"} value={form.link} onChange={(e) => setForm({ ...form, link: e.target.value })} data-testid="banner-link" />
        <input className="input-dark" placeholder={lang === "ar" ? "نص الزر" : "CTA label"} value={form.cta_label} onChange={(e) => setForm({ ...form, cta_label: e.target.value })} data-testid="banner-cta" />
        <input className="input-dark" type="number" placeholder={lang === "ar" ? "الترتيب" : "Position"} value={form.position} onChange={(e) => setForm({ ...form, position: Number(e.target.value) })} data-testid="banner-position" />
        <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={form.active} onChange={(e) => setForm({ ...form, active: e.target.checked })} className="accent-[#c9a55c]" /> {lang === "ar" ? "نشط" : "Active"}</label>
        <button type="submit" className="btn-primary sm:col-span-2" data-testid="banner-add"><Plus className="w-4 h-4" /> {lang === "ar" ? "إضافة بنر" : "Add banner"}</button>
      </form>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map(b => (
          <div key={b.id} className="surface rounded-xl overflow-hidden" data-testid={`banner-${b.id}`}>
            {b.image && <img src={b.image} alt="" className="w-full h-32 object-cover" />}
            <div className="p-3">
              <div className="flex justify-between gap-2 items-start">
                <div>
                  <div className="font-display text-base">{b.title}</div>
                  {b.subtitle && <div className="text-xs text-[#6b6b6b]">{b.subtitle}</div>}
                </div>
                <span className={`pill text-[10px] ${b.active ? "pill-accent" : ""}`}>{b.active ? (lang === "ar" ? "نشط" : "Active") : (lang === "ar" ? "متوقف" : "Off")}</span>
              </div>
              <div className="text-xs text-[#8a8a8a] mt-1">#{b.position} · {b.cta_label || "—"}</div>
              <div className="flex gap-2 mt-3">
                <button onClick={() => toggle(b)} className="btn-ghost text-xs">{b.active ? (lang === "ar" ? "إيقاف" : "Disable") : (lang === "ar" ? "تفعيل" : "Enable")}</button>
                <button onClick={() => del(b.id)} className="btn-ghost text-xs text-red-700 border-red-300"><Trash2 className="w-3 h-3" /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
